import {
  applyMiddleware,
  createStore,
  compose,
} from 'redux'
import {
  save,
  load,
} from 'redux-localstorage-simple'

import { createEpicMiddleware } from 'redux-observable'

import { rootEpic, rootReducer } from '../pages/actions'
import getStates from './states'

const epicMiddleware = createEpicMiddleware()

const enhancers = compose(applyMiddleware(
  epicMiddleware,
  save({ states: getStates() })
))

const store = createStore(
  rootReducer,
  load({ states: getStates() }),
  enhancers
)

epicMiddleware.run(rootEpic)

export default store
